import React from 'react'
import './css/item.css'
import { Link } from 'react-router-dom'
import LazyImage from './skeletons/LazyImage'

const Item = (props) => {
    const S3Url = process.env.REACT_APP_S3_PATH;

    return (
        <div className='item'>
            <Link to={`/product/${props.id}`} onClick={() => window.scrollTo(0, 0)}>
                <LazyImage
                    src={S3Url + props.image}
                    alt={props.name}
                    className="item-image"
                />
            </Link>
            <p>{props.name}</p>
            <div className="item-prices">
                <span className='item-price-new'>${props.new_price}</span>
                <span className='item-price-old'>${props.old_price}</span>
            </div>
        </div>
    )
}

export default Item